<doc>地图组件</doc>
<template>
  <div class="map-div controls">
    <!-- 地图渲染DOM -->
    <div id="map-ol"></div>
    <div class="leftCon" :style="{ top: '30px', left: '31px' }">
      <div class="leftBox">
        <div class="flexBox">
          <div class="leftTopTit">种植基地列表</div>
          <div class="rightBtn" @click="typeSet()">类别设置</div>
        </div>
        <div class="leftSty">
          <div
            class="leftTwo"
            v-for="(item, index) in options"
            :key="'imgConT' + index"
          >
            <div class="flexBox">
              <div class="leftTit">{{ item.baseName }}</div>
              <div class="rightType color" v-if="item.baseType == 0">种植基地</div>
              <div class="rightType color1" v-if="item.baseType == 1">养殖基地</div>
              <div class="rightType color2" v-if="item.baseType == 2">加工基地</div>
              <div class="rightType color3" v-if="item.baseType == 3">仓储基地</div>
            </div>
            
            <div class="let-container" @click="Basedetails(item.id)">
              <div class="imgConT">
                <img v-if="item.url" :src="commenUrl + item.url" alt="" />
                <img v-else src="../../assets/images/Baseimg.svg" />
              </div>
              <ul class="leftTwoTit">
                <li>
                  <div>{{tool.getDictLabel("base_type", item.baseType)}}</div>
                  <div style="margin: 0 20px" v-if="item.baseArea">|</div>
                  <div v-if="item.baseType == '2'||item.baseType == '3'">{{ item.baseArea }}平方</div>
                  <div v-else>{{ item.baseArea }}亩</div>
                </li>
                <li>
                  {{item.tags||'-'}}
                </li>
                <li v-if="item.categoryNames">
                  <div>{{ item.categoryNames }}</div>
                </li>
                <li>
                  <div>{{ item.conter }} / {{ item.tel }}</div>
                </li>
                <li>
                  <div style="line-height: 18px">{{ item.addrDetail||'-' }}</div>
                </li>
              </ul>
            </div>
            <div class="lines"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="typeCountBox">
      <div class="countItem color" v-for="(item,index) in countList" :key="index" :class="{'color1':item.baseType=='1','color2':item.baseType=='2','color3':item.baseType=='3'}">
        <div class="colorBox" v-if="item.show"></div>
        <div v-if="item.show">{{tool.getDictLabel("base_type", item.baseType)}}-{{item.count}}</div>
      </div>
    </div>
    <div class="dialog-none">
      <el-dialog v-if="dialogVisibledetails" title="" v-model="dialogVisibledetails" width="560px" :modal="false"
        custom-class="dialogdetails" :before-close="handleCloses"
      >
        <div class="details-body">
          <div v-if="!typeSetFlag">
            <p class="details-title">{{ pageData.baseName }}</p>
            <div class="details-header">
              <div class="details-left">
                <img v-if="pageData.url" :src="commenUrl + pageData.url" alt="" />
                <img v-else src="../../assets/images/Baseimg.svg" />
              </div>
              <div class="details-right">
                <p class="details-text">
                  <span>{{tool.getDictLabel("base_type", pageData.baseType)}}</span>
                  <span style="margin: 0 20px" v-if="pageData.baseArea">|</span>
                  <span v-if="pageData.baseType == '2'||pageData.baseType == '3'">{{ pageData.baseArea }}平方</span>
                  <span v-else>{{ pageData.baseArea }}亩</span>
                </p>
                <p class="details-text">{{pageData.tags||'-'}}</p>
                <p class="details-text">
                  {{ pageData.conter }} / {{ pageData.tel }}
                </p>
                <p class="details-text">{{ pageData.addrDetail ||'-'}}</p>
              </div>
            </div>
            <div class="details-titles">基地概述</div>
            <p class="details-introduce">
              {{ pageData.baseDesc }}
            </p>
          </div>
          <div v-else>
            <div class="checkedBox">
              <div class="labelT">基地类型</div>
              <el-checkbox-group v-model="dataType">
                <el-checkbox v-for="item in countList" :key="item.baseType" :label="item.baseType">
                {{tool.getDictLabel("base_type", item.baseType)}}
                </el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
          <div class="posdetailsimg" @click="handleCloses">
            <img src="../../assets/images/Cancel.svg" alt="" />
          </div>
          <div class="btnBox" v-if="typeSetFlag">
            <div class="btn cancelBtn" @click="dialogVisibledetails = false">取消</div>
            <div class="btn confirmBtn" @click="checkedFn">确定</div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import MapObject from "../../views/bigData/js/map";
import layerSelect from "./components/layerSelect.vue";
import statusBar from "./components/statusBar.vue";
import polygonMap from "./components/polygonMap.vue";
import { request } from "../../../public/js/request";
import store from "../../store";
export default {
  components: {
    layerSelect, // 图层选择组件
    statusBar, // 状态栏
    polygonMap, // 鼠标绘制多边形
  },
  
  data() {   
    return {
      countList:[],
      mapObject: null, // 地图引擎加载对象
      mapTypeName: "TSLM", // 地图引擎默认加载底图。可选择值：GDM、TSM、TSLM、Google、OMS（默认）
      layerSelectShow: false, // 是否开启底图选择器。true 显示比例尺；flase 不显示比例尺
      mapConfig: {
        // 地图属性配置
        mouseMove: true, // 开始鼠标移动事件
        mapMoved: true, // 地图移动完成事件
        mouseDraw: true, // 鼠标绘制
        scale:false
      },
      mapCenter:[117.6841, 40.51662],
      mapLevel:14,
      options: [],
      dialogVisibledetails: false,
      pageData: {},
      dataType:[],
      typeSetFlag:false,
    };
  },

  watch: {
    mapTypeName: {
      // 监听底图切换
      handler(newVal, oldVal) {
        this.mapObject.changeMap(this.mapTypeName);
      },
    },
    dialogVisib(newVal, oldVal) {
      this.dialogVisibledetails = newVal;
      if (newVal) {
        this.mapFn(store.state.id);
      }
    },
  },
  computed: {
    dialogVisib() {
      return store.state.dialogVisibledetails;
    },
  },
  mounted() {
    this.getSetData();
    this.getCount();
  },

  methods: {
    getSetData(){
      request({
        url: "N_FINDDEFAULT",
        method: "post", //可以不传method 默认是post请求，
        data: {},
      }).then((res) => {
        if (res.data.code == "000") {
          this.mapCenter = res.data.result.mapCentre.split(',');
          this.mapLevel = res.data.result.mapTier;
          this.$nextTick(()=>{
            this.initMap(); // 初始化地图引擎
          })
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    getList() {
      let selectedData ;
      if(this.dataType&&this.dataType.length>0){
        selectedData = JSON.parse(JSON.stringify(this.dataType))
        selectedData = selectedData.join(',')
      }
      request({
        url: "N_FINDDISTLIST",
        method: "post", //可以不传method 默认是post请求，
        data: {
          pageInfo: {
            pageNo: 1,
            pageSize: 1000,
          },
           baseMapType:selectedData
        },
      }).then((res) => {
        if (res.data.code == "000") {
          this.options = res.data.result.list;
          let arr = [];
          this.options.forEach((item, index) => {
            arr.push({
              id: item.id,
              longitude: item.jd,
              latitude: item.wd,
              type:'type'+item.baseType
            });
          });
          this.mapObject.addPointIcons("wjwDraw", arr);
          this.mapObject.arr(this.options,"wjwDraw1");
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    //获取数据统计
    getCount(){
      request({
        // ENTPBASEMAGE_FINDPAGELIST
        url: "N_TYPECOUNT",
        method: "post", //可以不传method 默认是post请求，
        data: {},
      }).then((res) => {
          if (res.data.code == "000") {
            this.countList = res.data.result.map((e)=>{
              e['show'] = true;
              return {...e}
            });
            console.log(this.countList,'wwwwww')
          }
        }).catch((err) => {
          console.log(err);
        });
    },
    // 类别设置
    typeSet(){
      this.dialogVisibledetails = true;
      this.typeSetFlag = true;
      if(this.dataType&&this.dataType.length>0){

      }else{
        this.dataType = this.countList.map(e=>e.baseType)
      }
    },
    checkedFn(){
      if(this.dataType.length>0){
        this.countList.forEach((item)=>{
          item.show = false
          this.dataType.forEach((innerItem)=>{
            if(item.baseType==innerItem){
              item.show = true
            }
          })
        })
      }else{
        this.countList.map((e)=>{
          e.show = true;
          return e
        })
      }
      this.getList()
      this.dialogVisibledetails = false;
    },
    // 初始化地图引擎
    initMap() {
      // 初始化地图引擎。(DOM ID，初始中心点坐标数组, 初始层级, 初始底图, 其他配置对象)
      this.mapObject = new MapObject(
        "map-ol",
        this.mapCenter,
        this.mapLevel,
        this.mapTypeName,
        {
          scale: true, // 开启比例尺
          ...this.mapConfig,
        }
      );
      this.getList();
      // this.mapObject.addGeojson("wjwDraw");
    },

    // 完成绘制覆盖物回调
    drawFinsh(points) {
      console.log(points);
    },
    Basedetails(id) {
      this.dialogVisibledetails = true;
      this.typeSetFlag = false;
      this.mapFn(id);
    },
    mapFn(id) {
      //首页-首页基地设备相关
      request({
        // ENTPBASEMAGE_FINDINFO
        url: "N_FINDINFO",
        method: "post",
        data: {
          id,
        },
      }).then((response) => {
        var resp = response.data.result;
        if (response.data.code == "000") {
          this.pageData = resp;
        } else {
          this.$alert(response.data.msg || "数据请求失败，请重试", "提示", {
            type: "error",
            confirmButtonText: "确定",
          });
        }
      });
    },

    handleCloses() {
      this.dialogVisibledetails = false;
      let obj = {
        Visnle: false,
        id: "",
      };
      store.commit("dialogVisible", obj);
    },
  },
};
</script>
<style  lang="less" scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
.map-div,
#map-ol {
  height: 100%;
  width: 100%;
  background-color: #a4cdff;
  position: relative;
}
::-webkit-scrollbar {
  display: none;
}
// .map-div{
  .flexBox{
    display: flex;
    justify-content: space-between;
  }
  div /deep/.ol-attribution,
  div /deep/.ol-zoom {
    display: none;
  }

  .draw-div {
    position: absolute;
    right: 20px;
    top: 10px;
    font-size: 12px;
    padding: 5px 10px;
    background-color: #fff;
    box-shadow: 0 2px 2px rgb(0 0 0 / 15%);
  }

  .draw-btn {
    width: 100%;
    margin: 5px 0;
    cursor: pointer;
  }
  .leftCon {
    position: absolute;
    width: 350px;
    height: 600px;
    z-index: 99;
    background-color: rgba(3, 26, 39, 0.8);
  }
  .leftBox {
    width: 100%;
    height: 100%;
    display: flex;
    box-sizing: border-box;
    flex-direction: column;
    background: url(../../assets/images/Blueline.png) no-repeat;
    background-origin: padding-box;
    background-position: center bottom;
    // padding-bottom: -1px;
    .flexBox{
      margin-bottom: 15px;
      .leftTopTit {
        line-height: 38px;
        font-size: 15px;
        font-weight: 500;
        border-image-source: linear-gradient(90deg, #ffe887 0%, #ffcc4f 100%);
        color: #ffcc4f;
        background: url(../../assets/images/titBgbor.png) no-repeat;
        height: 38px;
        padding-left: 32px;
      }
      .rightBtn{
        font-size: 13px;
        color: #ffcc4f;
        line-height: 38px;
        padding-right: 15px;
        cursor: pointer;
        text-decoration: underline;
        font-weight:500px;
      }
    }
    .leftSty {
      width: 100%;
      flex: 1;
      padding: 0 15px;
      overflow: auto;
      box-sizing: border-box;
      -ms-overflow-style: none;  /* IE 10+ */
      scrollbar-width: none;  /* Firefox */
      .selectCon {
        width: 265px;
        height: 34px;
        .el-select {
          display: block;
          opacity: 0.9;
        }
        .el-input__inner {
          background-color: #2f4252;
          border: 1px solid #5e6e8a;
          border-radius: 0;
          color: #a4b9d2;
        }
      }
      .leftTwo {
        // display: flex;
        // margin-top: 15px;
        // justify-content: center;
        // align-items: center;
        box-sizing: border-box;
        .flexBox{
          margin-bottom: 12px;
          .leftTit {
              max-width: 250px;
              font-size: 16px;
              font-weight: 500;
              color: #ffb74e;
              line-height: 18px;
              overflow: hidden;    /*   超出容器的部分影响  */
              white-space: nowrap;   /*  文本不换行   */
              text-overflow: ellipsis;   /*  超出容器的文本显示省略号  */
              // margin-bottom: 15px;
            }
          .rightType{
            width: 54px;
            height: 18px;
            line-height: 18px;
            text-align: center;
            background-color: #68604e;
            border-radius: 2px;
            font-family: PingFangSC-Regular;
            font-size: 12px;
            color: #ffcc4f;
          }
          .color1{
            background-color: #125141;
            color: #40ffd1;
          }
          .color2{
            background-color: #5a0933;
            color: #ec58a5;
          }
          .color3{
            background-color: #002f9d;
            color: #9cbbff;
          }
        }
        .let-container {
          display: flex;

          cursor: pointer;
          // justify-content: center;
          align-items: center;
          box-sizing: border-box;
          .imgConT {
            margin-right: 14px;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;
            display: flex;
            justify-content: center;
            align-items: center;
            img {
              width: 80px;
              height: 80px;
            }
          }
        }
      }
      .leftTwoTit {
        // margin-left: 10px;
        flex: 1;
        .leftTit {
          font-size: 16px;
          font-weight: 500;
          color: #ffb74e;
          line-height: 18px;
          overflow: hidden;    /*   超出容器的部分影响  */
          white-space: nowrap;   /*  文本不换行   */
          text-overflow: ellipsis;   /*  超出容器的文本显示省略号  */
          // margin-bottom: 15px;
        }
        li {
          font-size: 14px;
          font-weight: 500;
          color: #bac3c4;
          line-height: 22px;
          display: flex;
        }
      }
      .lines {
        width: 100%;
        height: 1px;
        opacity: 0.5;
        border: 1px solid #5e6e8a;
        margin: 12px 0 12px 0;
      }
      .sbList {
        .leftTh {
          display: flex;
          align-items: center;
          .listIten {
            width: 3px;
            height: 10px;
            background: #ffc269;
          }
          .leftThTit {
            font-size: 14px;
            font-weight: 500;
            color: #ffffff;
            line-height: 14px;
            margin-left: 12px;
          }
        }
        .listItem {
          display: flex;
          justify-content: space-between;
          margin-top: 12px;
          ul {
            line-height: 20px;
            margin-left: 12px;
            li {
              font-weight: 500;
              color: #9aaec6;
              line-height: 20px;
              margin-top: 5px;
              span {
                font-size: 14px;
                font-weight: 500;
                color: #fcd442;
                line-height: 20px;
              }
            }
          }
        }
      }
      .vedioSty {
        margin-top: 25px;
        .vedioCon {
          width: 100%;
          height: 146px;
          margin-left: 12px;
          /* margin-top: 17px; */
          position: relative;
          img {
            width: 100%;
            height: 100%;
          }
          .posImg {
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
        }
        .vedioBg {
          background-color: #ddd;
        }
      }
    }
  }
  :deep(.el-dialog){
    background-color: transparent !important;
    .el-dialog__header {
      display: none !important;
    }
  }
  .dialogdetails{
    .checkedBox{
      padding-top: 20px;
      .labelT{
        font-size: 16px;
        color: #2cf2f0;
        line-height: 22px;
        margin-bottom: 10px;
      }
      :deep(.el-checkbox) {
        font-size: 14px;
        color: #bac3c4;
        margin-right: 10px;
      }
      :deep(.el-checkbox__inner){
        width: 18px;
        height: 18px;
        border: solid 1px #bac3c4;
        background: transparent;
      }
      :deep(.el-checkbox__input.is-checked+.el-checkbox__label){
        font-size: 14px;
        color: #bac3c4;
      }
      :deep(.el-checkbox__input.is-checked .el-checkbox__inner){
        background: url("../../assets/images/mapChecked.png") no-repeat;
        background-size: 100% 100%;
        border:none;
      }
      :deep(.el-checkbox__inner::after){
        border: none;
      }
    }
    .btnBox{
      width: 84%;
      bottom: 50px;
      position: absolute;
      display: flex;
      justify-content: center;
      .btn{
        cursor: pointer;
        text-align: center;
        line-height: 28px;
        width: 94px;
	      height: 28px;
        background: url("../../assets/images/mapBtn.png") no-repeat;
        color: #678d97;
      }
      .confirmBtn{
        background: url("../../assets/images/mapBtn1.png") no-repeat;
        color: #5df1f1;
        margin-left: 26px;
      }
    }
  }
  .details-body {
    height: 405px !important;
    background: url("../../assets/images/Pop-up-box.svg") no-repeat;
    background-size: 100% 100%;
    position: relative;
    padding: 0 40px;
    .details-header {
      display: flex;
      // padding: 32px 0 0 0;
      .details-left {
        width: 80px;
        height: 82px;
        display: flex;
        justify-content: center;
        align-items: center;
        margin-right: 14px;
        img {
          width: 80px;
          height: 80px;
        }
      }
    }
  }
  .posdetailsbtn {
    position: absolute;
    bottom: 15px;
    right: 0;
    color: #3bc8c8;
    font-size: 14px;
    width: 100%;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .details-btn {
      width: 133px;
      height: 28px;
      border-width: 1px;
      border-image-slice: 1;
      background: url("../../assets/images/dis-btn.svg") no-repeat;
      background-size: 100% 100%;
      text-align: center;
      line-height: 28px;
      cursor: pointer;
    }
  }
  .details-titles {
    font-size: 14px;
    font-weight: 400;
    color: #ffcc4f;
    padding-left: 5px;
    margin: 10px 0 8px 0;
  }
  .details-introduce {
    font-size: 13px;
    color: #93a0a2;
    line-height: 16px;
    height: 190px;
    overflow: auto;
    padding-left: 5px;
  }
  .details-equipment {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    line-height: 20px;
    color: #93a0a2;
    font-size: 13px;
    padding-left: 5px;
    .flex-equipment {
      width: 33%;
      display: flex;
      div {
        width: 65px;
        display: flex;
        justify-content: right;
      }
      span {
        color: #ffffff;
      }
    }
  }

  .details-right {
    .details-text {
      font-size: 14px;
      line-height: 22px;
      color: #ffffff;
    }
  }
  .details-title {
    font-size: 16px;
    font-weight: 400;
    color: #ffcc4f;
    padding: 20px 0 10px 2px;
  }
  .dialogdetails {
    background: transparent;
    box-shadow: none;
  }
  .posdetailsimg {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 20px;
    right: 30px;
    cursor: pointer;
    img {
      widows: 100%;
      height: 100%;
    }
  }
  .controls .ol-control {
    display: none;
  }
  .typeCountBox {
    position: absolute;
    bottom: 20px;
    right: 31px;
    z-index: 99;
    color: #ffcc4f;
    font-family: PingFangSC-Regular;
    font-size: 12px;
    line-height: 12px;
    background-color: #031a27;
    opacity: 0.7;
    display: flex;
    padding: 11px 30px 11px 0;
    padding-right: 30px;
    .countItem{
      color: #ffcc4f;
      display: flex;
      .colorBox{
        margin-left: 30px;
        width: 10px;
        height: 10px;
        background-color: #ffcc4f;
        margin-right: 10px;
      }
    }
    .color1{
      .colorBox{
        background-color: #40ffd1;
      }
      color: #40ffd1;
    }
    .color2 {
      .colorBox{
        background-color: #ec58a5;
      }
      color: #ec58a5;
    }
    .color3 {
      .colorBox{
        background-color: #4d85ff;
      }
      color: #4d85ff;
    }
  }
  
// }
</style>
